import { $, api, loadSiteSettings, initTheme, saveOwnerSession, ownerSession, toast } from './common.js'

initTheme()
loadSiteSettings()

const form = $('#loginForm')
const errBox = $('#error')
const params = new URLSearchParams(location.search)
const next = params.get('next')
const safeNext = next && /^\/(docs|settings|d\/|s\/)/.test(next) ? next : '/docs'

function showError (msg) { errBox.textContent = msg; errBox.classList.toggle('hidden', !msg) }

// si ya hay sesión válida, entrar directamente
const sess = ownerSession()
if (sess) {
  api('/api/me', { token: sess.token }).then(() => { location.replace(safeNext) }).catch(() => {})
}
if (params.get('expired')) showError('Tu sesión ha caducado. Vuelve a entrar.')

form.addEventListener('submit', async e => {
  e.preventDefault()
  showError('')
  const btn = $('#loginBtn')
  btn.disabled = true
  try {
    const r = await api('/api/login', { method: 'POST', body: { username: $('#username').value, password: $('#password').value } })
    saveOwnerSession(r.token, r.username)
    toast(`Hola, ${r.username}`, 'ok')
    location.href = safeNext
  } catch (err) {
    showError(err.message)
    $('#password').select()
  } finally { btn.disabled = false }
})
